import { useEffect, useRef } from 'react'

export default function ParticleBackground() {
  const canvasRef = useRef(null)
  const animRef = useRef(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return

    const ctx = canvas.getContext('2d')
    let width = (canvas.width = window.innerWidth)
    let height = (canvas.height = window.innerHeight)

    const PARTICLE_COUNT = 70
    const CONNECTION_DISTANCE = 150
    const GREEN = '0, 255, 65'
    const CYAN = '0, 212, 255'

    const particles = Array.from({ length: PARTICLE_COUNT }, () => ({
      x: Math.random() * width,
      y: Math.random() * height,
      vx: (Math.random() - 0.5) * 0.4,
      vy: (Math.random() - 0.5) * 0.4,
      radius: Math.random() * 2 + 1,
      color: Math.random() > 0.6 ? CYAN : GREEN,
      opacity: Math.random() * 0.6 + 0.2,
    }))

    function drawParticle(p) {
      ctx.beginPath()
      ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2)
      ctx.fillStyle = `rgba(${p.color}, ${p.opacity})`
      ctx.shadowBlur = 6
      ctx.shadowColor = `rgba(${p.color}, 0.5)`
      ctx.fill()
      ctx.shadowBlur = 0
    }

    function drawConnection(p1, p2, dist) {
      const opacity = (1 - dist / CONNECTION_DISTANCE) * 0.25
      const color = p1.color === CYAN || p2.color === CYAN ? CYAN : GREEN
      ctx.beginPath()
      ctx.moveTo(p1.x, p1.y)
      ctx.lineTo(p2.x, p2.y)
      ctx.strokeStyle = `rgba(${color}, ${opacity})`
      ctx.lineWidth = 0.5
      ctx.stroke()
    }

    function update() {
      ctx.clearRect(0, 0, width, height)

      particles.forEach((p, i) => {
        p.x += p.vx
        p.y += p.vy

        if (p.x < -10) p.x = width + 10
        if (p.x > width + 10) p.x = -10
        if (p.y < -10) p.y = height + 10
        if (p.y > height + 10) p.y = -10

        drawParticle(p)

        for (let j = i + 1; j < particles.length; j++) {
          const p2 = particles[j]
          const dx = p.x - p2.x
          const dy = p.y - p2.y
          const dist = Math.sqrt(dx * dx + dy * dy)
          if (dist < CONNECTION_DISTANCE) {
            drawConnection(p, p2, dist)
          }
        }
      })

      animRef.current = requestAnimationFrame(update)
    }

    update()

    const handleResize = () => {
      width = canvas.width = window.innerWidth
      height = canvas.height = window.innerHeight
    }

    window.addEventListener('resize', handleResize)

    return () => {
      cancelAnimationFrame(animRef.current)
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 pointer-events-none z-0"
      style={{ background: 'transparent' }}
    />
  )
}
